import React from "react";

import FieldWithTooltip from "@/Components/Tooltip/FieldWithToolTip";

function PasswordWithTooltip(): React.JSX.Element {
  const description =
    "Passwords must be at least 8 characters, include at least one number, one special character (e.g., !@#$%^&*()), one uppercase letter, and one lowercase letter.";
  return <FieldWithTooltip label={"Password"} description={description} />;
}

export default PasswordWithTooltip;
